export default __webpack_public_path__ + "static/media/add-circle.e9d67367.svg";